import { observable, action, runInAction, makeObservable } from 'mobx';

import { StoreExt } from '@utils/reactExt';

export class SequenceGetterStore extends StoreExt {
    constructor() {
        super();
        makeObservable(this);
    }

    timers: Array<number> = [1, 3, 7, 15];

    @observable
    currentIndex: number = 0;

    @action
    getNext(): number {
        if (this.currentIndex >= this.timers.length - 1) {
            return this.timers[this.timers.length - 1];
        }
        runInAction(() => {
            this.currentIndex = this.currentIndex + 1;
        });
        return this.timers[this.currentIndex];
    }

    @action
    reset() {
        runInAction(() => {
            this.currentIndex = 0;
        });
    }
}

export default new SequenceGetterStore();
